(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aa-product-options')) {
  customElements.define('aa-product-options', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.root = this.closest('[data-product-section]');
      this.blocked = this.root.querySelector('[data-variant-id]')?.disabled ?? true;
      this.addEventListener('change', event => {
        if (event.target.matches('[data-option-value-id]')) this.update(event.target);
      });
      this.querySelector('[data-option-retry]').addEventListener('click', () => this.update());
      this.root.addEventListener('submit', event => {
        if (this.blocked && event.target.matches('[data-product-form]')) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      this.showMedia(this.root.querySelector('[data-variant-id]')?.dataset.mediaId);
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    showMedia(id) {
      if (!id) return;
      const gallery = this.root.querySelector('[data-product-gallery]');
      const item = Array.from(gallery?.children || []).find(node => node.dataset.mediaId === id);
      if (item) gallery.scrollTo({left: item.offsetLeft, behavior: 'instant'});
    }
    async update(changed) {
      const sibling = changed?.dataset.productUrl;
      if (sibling && new URL(sibling, location.origin).pathname !== new URL(this.dataset.productUrl, location.origin).pathname) {
        location.assign(sibling);
        return;
      }
      this.controller?.abort();
      const controller = this.controller = new AbortController();
      const fields = this.querySelector('[data-option-fields]');
      const status = this.querySelector('[data-option-status]');
      const retry = this.querySelector('[data-option-retry]');
      const variant = this.root.querySelector('[data-variant-id]');
      const button = this.root.querySelector('[data-product-submit]');
      const payment = this.root.querySelector('[data-product-payment]');
      const focusedId = changed?.id;
      const url = new URL(location.href);
      url.searchParams.delete('variant');
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set('option_values', Array.from(fields.querySelectorAll('input:checked')).map(input => input.dataset.optionValueId).join(','));
      this.blocked = true;
      this.setAttribute('aria-busy', 'true');
      variant.disabled = true;
      button.disabled = true;
      if (payment) payment.hidden = true;
      status.textContent = this.dataset.loading;
      retry.hidden = true;
      try {
        const response = await fetch(url, {signal: controller.signal});
        if (!response.ok) throw new Error('Variant request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (controller !== this.controller) return;
        const next = html.querySelector('[data-product-section]');
        const nextFields = next?.querySelector('[data-option-fields]');
        const nextVariant = next?.querySelector('[data-variant-id]');
        const nextButton = next?.querySelector('[data-product-submit]');
        const nextPrice = next?.querySelector('[data-product-price]');
        if (!nextFields || !nextVariant || !nextButton || !nextPrice) throw new Error('Incomplete variant response');
        fields.replaceChildren(...nextFields.childNodes);
        variant.value = nextVariant.value;
        variant.disabled = nextVariant.disabled;
        variant.dataset.mediaId = nextVariant.dataset.mediaId;
        button.disabled = nextButton.disabled;
        button.textContent = nextButton.textContent;
        this.root.querySelector('[data-product-price]').innerHTML = nextPrice.innerHTML;
        if (payment) {
          const nextPayment = next.querySelector('[data-product-payment]');
          payment.innerHTML = nextPayment?.innerHTML || '';
          payment.hidden = nextButton.disabled;
          window.Shopify?.PaymentButton?.init?.();
        }
        const displayUrl = new URL(url);
        displayUrl.searchParams.delete('section_id');
        if (variant.value) {
          displayUrl.searchParams.delete('option_values');
          displayUrl.searchParams.set('variant', variant.value);
        }
        history.replaceState(history.state, '', displayUrl);
        this.showMedia(nextVariant.dataset.mediaId);
        status.textContent = nextButton.disabled ? nextButton.textContent : '';
        this.blocked = nextButton.disabled;
        if (focusedId) document.getElementById(focusedId)?.focus({preventScroll:true});
      } catch (error) {
        if (error.name === 'AbortError' || controller !== this.controller) return;
        status.textContent = this.dataset.error;
        retry.hidden = false;
      } finally {
        if (controller === this.controller) this.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
